/**
 * 周天至周六（英文）
 * @return {string[]}
 */
export const weekAryEn: string[] = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
]
